import { render } from "./projectsearch.vue?vue&type=template&id=6a677ced"
import script from "./projectsearch.vue?vue&type=script&lang=js"
export * from "./projectsearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__